<template>
	<div class="display-flex flex-justify-space-between on-boarding-step-wrapper">
		<div class="display-flex flex-column flex-justify-space-between">
			<div>
				<div class="on-boarding-step-explanation-text">
					Add-ons live inside your apps. They add buttons with superpowers<br />on-top of your app’s interface. They can:
				</div>
				<ul class="on-boarding-step-explanation-text">
					<li>Open interfaces inside your app</li>
					<li>Use data from the item you’re currently on</li>
					<li>Get and send data to other apps</li>
				</ul>
			</div>
			<div class="display-flex flex-row flex-align-center">
				<AnemicButton :disabled="isCompleted" @click="markAsComplete" tile class="on-boarding-step-finish-step-button">Got it</AnemicButton>
			</div>
		</div>
		<div class="image-container">
			<v-img :src="OnBoardingAddOnsImage" />
		</div>
	</div>
</template>

<script>
import OnBoardingAddOnsImage from '@/assets/icons/on-boarding-add-ons.png';
export default {
	name: 'OnBoardingGetToKnowAddOns',
	props: { stepDetails: { type: Object } },
	components: {},
	computed: {
		isCompleted() {
			return this.stepDetails.isCompleted;
		},
	},
	methods: {
		markAsComplete() {
			this.$emit('mark-step-as-done', this.stepDetails);
		},
	},
	created() {},
	data() {
		return { OnBoardingAddOnsImage };
	},
};
</script>

<style scoped lang="scss">
.image-container {
	width: 433px;
	height: 257px;
}
</style>
